/**
 * Component Translations Index
 * 
 * Import and export all component-specific translations here.
 * This allows components to maintain their own translation files.
 */

import { topUpBalanceTranslations } from './TopUpBalance-i18n';
import { homePageTranslations } from './HomePage-i18n';
import { profilePageTranslations } from './ProfilePage-i18n';
import { corePageContentTranslations } from './CorePageContent-i18n';
import { createCashTokenTranslations } from './CreateCashToken-i18n';
import { redeemTokenTranslations } from './RedeemToken-i18n';
import { loginTranslations } from './Login-i18n';
import { signupWithTypeTranslations } from './SignupWithType-i18n';
import { merchantOnboardingTranslations } from './MerchantOnboarding-i18n';
import { forgotPasswordTranslations } from './ForgotPassword-i18n';
import { resetPasswordTranslations } from './ResetPassword-i18n';
import { contactsTranslations } from './Contacts-i18n';
import { businessDetailTranslations } from './BusinessDetail-i18n';
import { notFoundTranslations } from './NotFound-i18n';
import { inboxPageTranslations } from './InboxPage-i18n';
import { paymentSourcesTranslations } from './PaymentSources-i18n';
import { addPaymentMethodTranslations } from './AddPaymentMethod-i18n';
import { transferOutTranslations } from './TransferOut-i18n';
import { topupPageTranslations } from './TopupPage-i18n';
import { transactionHistoryTranslations } from './TransactionHistory-i18n';
import { messagesTranslations } from './Messages-i18n';
import { merchantProfileTranslations } from './MerchantProfile-i18n';
import { merchantToolsTranslations } from './MerchantTools-i18n';
import { merchantStorefrontTranslations } from './MerchantStorefront-i18n';
import { merchantPublicProfileTranslations } from './MerchantPublicProfile-i18n';
import { invoicePaymentTranslations } from './InvoicePayment-i18n';
import { redeemTranslations } from './Redeem-i18n';
import { helpPageTranslations } from './HelpPage-i18n';
import { supportTranslations } from './Support-i18n';
import { cookiePolicyTranslations } from './CookiePolicy-i18n';
import { privacyPolicyTranslations } from './PrivacyPolicy-i18n';
import { termsOfServiceTranslations } from './TermsOfService-i18n';
import { productsTranslations } from './Products-i18n';
import { adminTranslations } from './Admin-i18n';
import { payTranslations } from './Pay-i18n';
import { marketplaceTranslations } from './Marketplace-i18n';
import { languageSelectorTranslations } from './LanguageSelector-i18n';
import { tokenCardTranslations } from './TokenCard-i18n';
import { pointsTranslations } from './Points-i18n';

/**
 * Merge all component translations into a single object
 * Each component's translations are merged by language
 */
export const componentTranslations = {
  en: {
    ...topUpBalanceTranslations.en,
    ...homePageTranslations.en,
    ...profilePageTranslations.en,
    ...corePageContentTranslations.en,
    ...createCashTokenTranslations.en,
    ...redeemTokenTranslations.en,
    ...loginTranslations.en,
    ...signupWithTypeTranslations.en,
    ...merchantOnboardingTranslations.en,
    ...forgotPasswordTranslations.en,
    ...resetPasswordTranslations.en,
    ...contactsTranslations.en,
    ...businessDetailTranslations.en,
    ...notFoundTranslations.en,
    ...inboxPageTranslations.en,
    ...paymentSourcesTranslations.en,
    ...addPaymentMethodTranslations.en,
    ...transferOutTranslations.en,
    ...topupPageTranslations.en,
    ...transactionHistoryTranslations.en,
    ...messagesTranslations.en,
    ...merchantProfileTranslations.en,
    ...merchantToolsTranslations.en,
    ...merchantStorefrontTranslations.en,
    ...merchantPublicProfileTranslations.en,
    ...invoicePaymentTranslations.en,
    ...redeemTranslations.en,
    ...helpPageTranslations.en,
    ...supportTranslations.en,
    ...cookiePolicyTranslations.en,
    ...privacyPolicyTranslations.en,
    ...termsOfServiceTranslations.en,
    ...productsTranslations.en,
    ...adminTranslations.en,
    ...payTranslations.en,
    ...marketplaceTranslations.en,
    ...languageSelectorTranslations.en,
    ...tokenCardTranslations.en,
    ...pointsTranslations.en,
  },
  fr: {
    ...topUpBalanceTranslations.fr,
    ...homePageTranslations.fr,
    ...profilePageTranslations.fr,
    ...corePageContentTranslations.fr,
    ...createCashTokenTranslations.fr,
    ...redeemTokenTranslations.fr,
    ...loginTranslations.fr,
    ...signupWithTypeTranslations.fr,
    ...merchantOnboardingTranslations.fr,
    ...forgotPasswordTranslations.fr,
    ...resetPasswordTranslations.fr,
    ...contactsTranslations.fr,
    ...businessDetailTranslations.fr,
    ...notFoundTranslations.fr,
    ...inboxPageTranslations.fr,
    ...paymentSourcesTranslations.fr,
    ...addPaymentMethodTranslations.fr,
    ...transferOutTranslations.fr,
    ...topupPageTranslations.fr,
    ...transactionHistoryTranslations.fr,
    ...messagesTranslations.fr,
    ...merchantProfileTranslations.fr,
    ...merchantToolsTranslations.fr,
    ...merchantStorefrontTranslations.fr,
    ...merchantPublicProfileTranslations.fr,
    ...invoicePaymentTranslations.fr,
    ...redeemTranslations.fr,
    ...helpPageTranslations.fr,
    ...supportTranslations.fr,
    ...cookiePolicyTranslations.fr,
    ...privacyPolicyTranslations.fr,
    ...termsOfServiceTranslations.fr,
    ...productsTranslations.fr,
    ...adminTranslations.fr,
    ...payTranslations.fr,
    ...marketplaceTranslations.fr,
    ...languageSelectorTranslations.fr,
    ...tokenCardTranslations.fr,
    ...pointsTranslations.fr,
  },
  es: {
    ...topUpBalanceTranslations.es,
    ...homePageTranslations.es,
    ...profilePageTranslations.es,
    ...corePageContentTranslations.es,
    ...createCashTokenTranslations.es,
    ...redeemTokenTranslations.es,
    ...loginTranslations.es,
    ...signupWithTypeTranslations.es,
    ...merchantOnboardingTranslations.es,
    ...forgotPasswordTranslations.es,
    ...resetPasswordTranslations.es,
    ...contactsTranslations.es,
    ...businessDetailTranslations.es,
    ...notFoundTranslations.es,
    ...inboxPageTranslations.es,
    ...paymentSourcesTranslations.es,
    ...addPaymentMethodTranslations.es,
    ...transferOutTranslations.es,
    ...topupPageTranslations.es,
    ...transactionHistoryTranslations.es,
    ...messagesTranslations.es,
    ...merchantProfileTranslations.es,
    ...merchantToolsTranslations.es,
    ...merchantStorefrontTranslations.es,
    ...merchantPublicProfileTranslations.es,
    ...invoicePaymentTranslations.es,
    ...redeemTranslations.es,
    ...helpPageTranslations.es,
    ...supportTranslations.es,
    ...cookiePolicyTranslations.es,
    ...privacyPolicyTranslations.es,
    ...termsOfServiceTranslations.es,
    ...productsTranslations.es,
    ...adminTranslations.es,
    ...payTranslations.es,
    ...marketplaceTranslations.es,
    ...languageSelectorTranslations.es,
    ...tokenCardTranslations.es,
  },
  sq: {
    ...topUpBalanceTranslations.sq,
    ...homePageTranslations.sq,
    ...profilePageTranslations.sq,
    ...corePageContentTranslations.sq,
    ...createCashTokenTranslations.sq,
    ...redeemTokenTranslations.sq,
    ...loginTranslations.sq,
    ...signupWithTypeTranslations.sq,
    ...merchantOnboardingTranslations.sq,
    ...forgotPasswordTranslations.sq,
    ...resetPasswordTranslations.sq,
    ...contactsTranslations.sq,
    ...businessDetailTranslations.sq,
    ...notFoundTranslations.sq,
    ...inboxPageTranslations.sq,
    ...paymentSourcesTranslations.sq,
    ...addPaymentMethodTranslations.sq,
    ...transferOutTranslations.sq,
    ...topupPageTranslations.sq,
    ...transactionHistoryTranslations.sq,
    ...messagesTranslations.sq,
    ...merchantProfileTranslations.sq,
    ...merchantToolsTranslations.sq,
    ...merchantStorefrontTranslations.sq,
    ...merchantPublicProfileTranslations.sq,
    ...invoicePaymentTranslations.sq,
    ...redeemTranslations.sq,
    ...helpPageTranslations.sq,
    ...supportTranslations.sq,
    ...cookiePolicyTranslations.sq,
    ...privacyPolicyTranslations.sq,
    ...termsOfServiceTranslations.sq,
    ...productsTranslations.sq,
    ...adminTranslations.sq,
    ...helpPageTranslations.sq,
    ...supportTranslations.sq,
    ...cookiePolicyTranslations.sq,
    ...privacyPolicyTranslations.sq,
    ...termsOfServiceTranslations.sq,
    ...productsTranslations.sq,
    ...adminTranslations.sq,
    ...payTranslations.sq,
    ...marketplaceTranslations.sq,
    ...languageSelectorTranslations.sq,
  },
  ru: {
    ...topUpBalanceTranslations.ru,
    ...homePageTranslations.ru,
    ...profilePageTranslations.ru,
    ...corePageContentTranslations.ru,
    ...createCashTokenTranslations.ru,
    ...redeemTokenTranslations.ru,
    ...loginTranslations.ru,
    ...signupWithTypeTranslations.ru,
    ...merchantOnboardingTranslations.ru,
    ...forgotPasswordTranslations.ru,
    ...resetPasswordTranslations.ru,
    ...contactsTranslations.ru,
    ...businessDetailTranslations.ru,
    ...notFoundTranslations.ru,
    ...inboxPageTranslations.ru,
    ...paymentSourcesTranslations.ru,
    ...addPaymentMethodTranslations.ru,
    ...transferOutTranslations.ru,
    ...topupPageTranslations.ru,
    ...transactionHistoryTranslations.ru,
    ...messagesTranslations.ru,
    ...merchantProfileTranslations.ru,
    ...merchantToolsTranslations.ru,
    ...merchantStorefrontTranslations.ru,
    ...merchantPublicProfileTranslations.ru,
    ...invoicePaymentTranslations.ru,
    ...redeemTranslations.ru,
    ...helpPageTranslations.ru,
    ...supportTranslations.ru,
    ...cookiePolicyTranslations.ru,
    ...privacyPolicyTranslations.ru,
    ...termsOfServiceTranslations.ru,
    ...productsTranslations.ru,
    ...adminTranslations.ru,
    ...payTranslations.ru,
    ...marketplaceTranslations.ru,
    ...languageSelectorTranslations.ru,
  },
  pt: {
    ...topUpBalanceTranslations.pt,
    ...homePageTranslations.pt,
    ...profilePageTranslations.pt,
    ...corePageContentTranslations.pt,
    ...createCashTokenTranslations.pt,
    ...redeemTokenTranslations.pt,
    ...loginTranslations.pt,
    ...signupWithTypeTranslations.pt,
    ...merchantOnboardingTranslations.pt,
    ...forgotPasswordTranslations.pt,
    ...resetPasswordTranslations.pt,
    ...contactsTranslations.pt,
    ...businessDetailTranslations.pt,
    ...notFoundTranslations.pt,
    ...inboxPageTranslations.pt,
    ...paymentSourcesTranslations.pt,
    ...addPaymentMethodTranslations.pt,
    ...transferOutTranslations.pt,
    ...topupPageTranslations.pt,
    ...transactionHistoryTranslations.pt,
    ...messagesTranslations.pt,
    ...merchantProfileTranslations.pt,
    ...merchantToolsTranslations.pt,
    ...merchantStorefrontTranslations.pt,
    ...merchantPublicProfileTranslations.pt,
    ...invoicePaymentTranslations.pt,
    ...redeemTranslations.pt,
    ...helpPageTranslations.pt,
    ...supportTranslations.pt,
    ...cookiePolicyTranslations.pt,
    ...privacyPolicyTranslations.pt,
    ...termsOfServiceTranslations.pt,
    ...productsTranslations.pt,
    ...adminTranslations.pt,
    ...payTranslations.pt,
    ...marketplaceTranslations.pt,
    ...languageSelectorTranslations.pt,
  },
  el: {
    ...topUpBalanceTranslations.el,
    ...homePageTranslations.el,
    ...profilePageTranslations.el,
    ...corePageContentTranslations.el,
    ...createCashTokenTranslations.el,
    ...redeemTokenTranslations.el,
    ...loginTranslations.el,
    ...signupWithTypeTranslations.el,
    ...merchantOnboardingTranslations.el,
    ...forgotPasswordTranslations.el,
    ...resetPasswordTranslations.el,
    ...contactsTranslations.el,
    ...businessDetailTranslations.el,
    ...notFoundTranslations.el,
    ...inboxPageTranslations.el,
    ...paymentSourcesTranslations.el,
    ...addPaymentMethodTranslations.el,
    ...transferOutTranslations.el,
    ...topupPageTranslations.el,
    ...transactionHistoryTranslations.el,
    ...messagesTranslations.el,
    ...merchantProfileTranslations.el,
    ...merchantToolsTranslations.el,
    ...merchantStorefrontTranslations.el,
    ...merchantPublicProfileTranslations.el,
    ...invoicePaymentTranslations.el,
    ...redeemTranslations.el,
    ...helpPageTranslations.el,
    ...supportTranslations.el,
    ...cookiePolicyTranslations.el,
    ...privacyPolicyTranslations.el,
    ...termsOfServiceTranslations.el,
    ...productsTranslations.el,
    ...adminTranslations.el,
    ...payTranslations.el,
    ...marketplaceTranslations.el,
    ...languageSelectorTranslations.el,
  },
  de: {
    ...topUpBalanceTranslations.de,
    ...homePageTranslations.de,
    ...profilePageTranslations.de,
    ...corePageContentTranslations.de,
    ...createCashTokenTranslations.de,
    ...redeemTokenTranslations.de,
    ...loginTranslations.de,
    ...signupWithTypeTranslations.de,
    ...merchantOnboardingTranslations.de,
    ...forgotPasswordTranslations.de,
    ...resetPasswordTranslations.de,
    ...contactsTranslations.de,
    ...businessDetailTranslations.de,
    ...notFoundTranslations.de,
    ...inboxPageTranslations.de,
    ...paymentSourcesTranslations.de,
    ...addPaymentMethodTranslations.de,
    ...transferOutTranslations.de,
    ...topupPageTranslations.de,
    ...transactionHistoryTranslations.de,
    ...messagesTranslations.de,
    ...merchantProfileTranslations.de,
    ...merchantToolsTranslations.de,
    ...merchantStorefrontTranslations.de,
    ...merchantPublicProfileTranslations.de,
    ...invoicePaymentTranslations.de,
    ...redeemTranslations.de,
    ...helpPageTranslations.de,
    ...supportTranslations.de,
    ...cookiePolicyTranslations.de,
    ...privacyPolicyTranslations.de,
    ...termsOfServiceTranslations.de,
    ...productsTranslations.de,
    ...adminTranslations.de,
    ...payTranslations.de,
    ...marketplaceTranslations.de,
    ...languageSelectorTranslations.de,
  },
  ro: {
    ...topUpBalanceTranslations.ro,
    ...homePageTranslations.ro,
    ...profilePageTranslations.ro,
    ...corePageContentTranslations.ro,
    ...createCashTokenTranslations.ro,
    ...redeemTokenTranslations.ro,
    ...loginTranslations.ro,
    ...signupWithTypeTranslations.ro,
    ...merchantOnboardingTranslations.ro,
    ...forgotPasswordTranslations.ro,
    ...resetPasswordTranslations.ro,
    ...contactsTranslations.ro,
    ...businessDetailTranslations.ro,
    ...notFoundTranslations.ro,
    ...inboxPageTranslations.ro,
    ...paymentSourcesTranslations.ro,
    ...addPaymentMethodTranslations.ro,
    ...transferOutTranslations.ro,
    ...topupPageTranslations.ro,
    ...transactionHistoryTranslations.ro,
    ...messagesTranslations.ro,
    ...merchantProfileTranslations.ro,
    ...merchantToolsTranslations.ro,
    ...merchantStorefrontTranslations.ro,
    ...merchantPublicProfileTranslations.ro,
    ...invoicePaymentTranslations.ro,
    ...redeemTranslations.ro,
    ...helpPageTranslations.ro,
    ...supportTranslations.ro,
    ...cookiePolicyTranslations.ro,
    ...privacyPolicyTranslations.ro,
    ...termsOfServiceTranslations.ro,
    ...productsTranslations.ro,
    ...adminTranslations.ro,
    ...payTranslations.ro,
    ...marketplaceTranslations.ro,
    ...languageSelectorTranslations.ro,
  },
  sr: {
    ...topUpBalanceTranslations.sr,
    ...homePageTranslations.sr,
    ...profilePageTranslations.sr,
    ...corePageContentTranslations.sr,
    ...createCashTokenTranslations.sr,
    ...redeemTokenTranslations.sr,
    ...loginTranslations.sr,
    ...signupWithTypeTranslations.sr,
    ...merchantOnboardingTranslations.sr,
    ...forgotPasswordTranslations.sr,
    ...resetPasswordTranslations.sr,
    ...contactsTranslations.sr,
    ...businessDetailTranslations.sr,
    ...notFoundTranslations.sr,
    ...inboxPageTranslations.sr,
    ...paymentSourcesTranslations.sr,
    ...addPaymentMethodTranslations.sr,
    ...transferOutTranslations.sr,
    ...topupPageTranslations.sr,
    ...transactionHistoryTranslations.sr,
    ...messagesTranslations.sr,
    ...merchantProfileTranslations.sr,
    ...merchantToolsTranslations.sr,
    ...merchantStorefrontTranslations.sr,
    ...merchantPublicProfileTranslations.sr,
    ...invoicePaymentTranslations.sr,
    ...redeemTranslations.sr,
    ...helpPageTranslations.sr,
    ...supportTranslations.sr,
    ...cookiePolicyTranslations.sr,
    ...privacyPolicyTranslations.sr,
    ...termsOfServiceTranslations.sr,
    ...productsTranslations.sr,
    ...adminTranslations.sr,
    ...payTranslations.sr,
    ...marketplaceTranslations.sr,
    ...languageSelectorTranslations.sr,
  },
  pl: {
    ...topUpBalanceTranslations.pl || {},
    ...homePageTranslations.pl || {},
    ...profilePageTranslations.pl || {},
    ...corePageContentTranslations.pl || {},
    ...createCashTokenTranslations.pl || {},
    ...redeemTokenTranslations.pl || {},
    ...loginTranslations.pl || {},
    ...signupWithTypeTranslations.pl || {},
    ...merchantOnboardingTranslations.pl || {},
    ...forgotPasswordTranslations.pl || {},
    ...resetPasswordTranslations.pl || {},
    ...contactsTranslations.pl || {},
    ...businessDetailTranslations.pl || {},
    ...notFoundTranslations.pl || {},
    ...inboxPageTranslations.pl || {},
    ...paymentSourcesTranslations.pl || {},
    ...addPaymentMethodTranslations.pl || {},
    ...transferOutTranslations.pl || {},
    ...topupPageTranslations.pl || {},
    ...transactionHistoryTranslations.pl || {},
    ...messagesTranslations.pl || {},
    ...merchantProfileTranslations.pl || {},
    ...merchantToolsTranslations.pl || {},
    ...merchantStorefrontTranslations.pl || {},
    ...merchantPublicProfileTranslations.pl || {},
    ...invoicePaymentTranslations.pl || {},
    ...redeemTranslations.pl || {},
    ...helpPageTranslations.pl || {},
    ...supportTranslations.pl || {},
    ...cookiePolicyTranslations.pl || {},
    ...privacyPolicyTranslations.pl || {},
    ...termsOfServiceTranslations.pl || {},
    ...productsTranslations.pl || {},
    ...adminTranslations.pl || {},
    ...payTranslations.pl || {},
    ...marketplaceTranslations.pl || {},
    ...languageSelectorTranslations.pl || {},
  },
};

